import React from 'react';
import { Box, DialogContent, Stack, Typography } from '@mui/material';
import { IconCloudUpload, IconIIRoundFilled } from '@maiia/design-system';
import { styled, css } from '@mui/material/styles';
import { useTranslation } from '@/src/i18n';
import DocumentButton from '@/components/molecules/DocumentButton/DocumentButton';

/* JS styling */

const OptionList = styled(Stack)(
  () => css`
    width: 100%;
  `,
);

const OptionItem = styled(Box)(
  ({ theme }) => css`
    width: 50%;
    padding: ${theme.spacing(2, 2, 4, 2)};
    text-align: center;
    background-color: ${theme.palette.background.secondary};

    &:hover {
      cursor: pointer;

      .MuiButtonBase-root {
        color: ${theme.palette.secondary.main};
      }
    }
  `,
);

type Props = {
  showShareDocumentChooseDialog: () => void;
  showShareDocumentUploadDialog: () => void;
};

/* Component */

const ShareDocumentDialog = ({
  showShareDocumentChooseDialog,
  showShareDocumentUploadDialog,
}: Props) => {
  const { t } = useTranslation();

  return (
    <DialogContent
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: { xs: 2, sm: 4 },
      }}
    >
      <OptionList direction="row" spacing={2}>
        <OptionItem
          display="flex"
          flexDirection="column"
          justifyContent="center"
          onClick={showShareDocumentUploadDialog}
        >
          <DocumentButton>
            <IconCloudUpload />
          </DocumentButton>
          <Typography>{t('rdv_share_document_share_new')}</Typography>
        </OptionItem>
        <OptionItem
          display="flex"
          flexDirection="column"
          justifyContent="center"
          onClick={showShareDocumentChooseDialog}
        >
          <DocumentButton>
            <IconIIRoundFilled />
          </DocumentButton>
          <Typography>{t('rdv_share_document_share_exist')}</Typography>
        </OptionItem>
      </OptionList>
    </DialogContent>
  );
};

export default ShareDocumentDialog;
